<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <reports />
    </div>
  </div>
</template>

<script>
import Reports from '../components/Reports.vue';

export default {
    components: {
        Reports
    },
}
</script>
